/**
 * QB User model
 */
export class QBUser {
  name?: string;
  id?:string;
  userName?:string;
  email?: string;

  constructor(data?: any) {
    if (!data) {
      return;
    }

    this.name = data.name?data.name.replace(/"/g, ''):undefined;
    this.id = data.id?data.id.replace(/"/g, ''):undefined;
    this.userName = data.userName?data.userName.replace(/"/g, ''):undefined;
    this.email = data.email?data.email.replace(/"/g, ''):undefined;
  }
}
